module.exports = function() {
  return new Worker(__webpack_public_path__ + "12a2de4a8c6ca9d70edd.worker.js");
};